import { render, staticRenderFns } from "./PlaylistItemImage.vue?vue&type=template&id=20c94ace&scoped=true"
import script from "./PlaylistItemImage.vue?vue&type=script&lang=js"
export * from "./PlaylistItemImage.vue?vue&type=script&lang=js"
import style0 from "./PlaylistItemImage.vue?vue&type=style&index=0&id=20c94ace&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c94ace",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20c94ace')) {
      api.createRecord('20c94ace', component.options)
    } else {
      api.reload('20c94ace', component.options)
    }
    module.hot.accept("./PlaylistItemImage.vue?vue&type=template&id=20c94ace&scoped=true", function () {
      api.rerender('20c94ace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screens/PlaylistItemImage.vue"
export default component.exports